import { ServiceViewStore } from "@intrasync/react";
import DatabaseManagerStore from "./views/admin/DatabaseManager/DatabaseManagerStore";
import { UIStore } from "@intrasync/stores/features";
import { SettingsStore } from "@intrasync/stores";
import ClientStore from "./stores/ClientStore";
import ApiNotificationStore from "./stores/ApiNotificationStore";
import RealtimeStore from "./stores/RealtimeStore";
import SettingsSyncStore from "./stores/SettingsSyncStore";
import NotificationSettingsStore from "./stores/NotificationSettingsStore";
import PushNoticeStore from "./stores/PushNoticeStore";
import PageAccessStore from "./stores/PageAccessStore";
import DiagnosticsStore from "./stores/DiagnosticsStore";

// Import store lists from each view group
import adminStoreList from "./views/admin/adminStoreList";
import administrationStoreList from "./views/administration/administrationStoreList";
import billingStoreList from "./views/billing/billingStoreList";
import homeStoreList from "./views/home/homeStoreList";
import clientsStoreList from "./views/clients/clientsStoreList";
import whiteboardStoreList from "./views/whiteboard/whiteboardStoreList";
import ticketsStoreList from "./views/tickets/ticketsStoreList";
import modulesStoreList from "./views/modules/modulesStoreList";
import devopsStoreList from "./views/devops/devopsStoreList";
import infrastructureStoreList from "./views/infrastructure/infrastructureStoreList";
import meetingIntelligenceStoreList from "./views/meetingIntelligence/meetingIntelligenceStoreList";
import aiStoreList from "./views/ai/aiStoreList";
import dataMapperStoreList from "./views/dataMapper/dataMapperStoreList";
import reportsStoreList from "./views/reports/reportsStoreList";
import DeviceApprovalStore from "./views/device/DeviceApprovalStore";
// EMPTY BY DESIGN: the dashboard builds its view stores lazily on first mount
// (parked on rootStore.intraSyncDashboardStore / …BoardAdminStore), not through
// the app-store roster. Spread anyway so HQ's composition root carries the
// library's full §1.11 triple (routes + serviceStores + appStores) uniformly.
import { dashboardAppStores } from "@intrasync/dashboard";
// EMPTY BY DESIGN as well: the reports hub parks its view store on
// rootStore.intraSyncReportsStore on first mount. Spread for the same reason.
import { reportsAppStores } from "@intrasync/reports";

const appStores = [
  // Core stores
  { name: "databaseManagerStore", store: DatabaseManagerStore },
  { name: "uiStore", store: UIStore },
  // `settingsStore` is a RESERVED library key: the library RootStore mounts its
  // own SettingsStore (the same class). HQ's remaining composition-root fork
  // does not, so the entry has to stay here — but it must be DELETED in the
  // same change that adopts the library RootStore, or the two collide.
  { name: "settingsStore", store: SettingsStore },
  // Must follow `settingsStore`: connects it to the user-preferences DB service.
  { name: "settingsSyncStore", store: SettingsSyncStore },
  // Settings -> Notifications: the per-person opt-in switches and this device push subscription.
  { name: "notificationSettingsStore", store: NotificationSettingsStore },
  { name: "serviceViewStore", store: ServiceViewStore },
  { name: "clientStore", store: ClientStore },
  { name: "apiNotificationStore", store: ApiNotificationStore },
  // The one-time "Turn on phone push" notice in the bell. Reads the bell's rows
  // and the settings store's switches, so it follows both.
  { name: "pushNoticeStore", store: PushNoticeStore },
  { name: "realtimeStore", store: RealtimeStore },
  // Signed-in user's page-access deny rules (PermissionManager reads these).
  { name: "pageAccessStore", store: PageAccessStore },
  // Reactive facade over the DiagnosticsSink's retained ring buffer + boot log
  // (src/diagnostics/). The buffer itself is module-scope, not owned here — it
  // has to exist before any store does, because the events fired inside the
  // RootStore constructor are the ones worth keeping.
  { name: "diagnosticsStore", store: DiagnosticsStore },

  // View group stores
  ...adminStoreList,
  ...administrationStoreList,
  ...billingStoreList,
  ...homeStoreList,
  ...clientsStoreList,
  ...whiteboardStoreList,
  ...ticketsStoreList,
  ...modulesStoreList,
  ...devopsStoreList,
  ...infrastructureStoreList,
  ...meetingIntelligenceStoreList,
  ...aiStoreList,
  ...dataMapperStoreList,
  ...reportsStoreList,
  // /device: a signed-in person approves a device sign-in (views/device/).
  { name: "deviceApprovalStore", store: DeviceApprovalStore },
  ...(dashboardAppStores as unknown as { name: string; store: unknown }[]),
  ...(reportsAppStores as unknown as { name: string; store: unknown }[]),
];

export default appStores;
